import React from 'react';
import { Fragment } from 'react';
import Logo from './logo';
import WordSearchContainer from '../../containers/word_search';
import NewestWordsContainer from '../../containers/newest_words';
import MostTackedWordsContainer from '../../containers/most_tacked_words';
import FollowsFeedContainer from '../../containers/follows_feed';

export default class LoggedIn extends React.Component {
  render() {
    return(
      <Fragment>
        <Logo />
        <div className='home-section'>
          <WordSearchContainer />
        </div>
        <div className='home-section'>
          <NewestWordsContainer />
        </div>
        <div className='home-section'>
          <MostTackedWordsContainer />
        </div>
        <div className='home-section'>
          <FollowsFeedContainer />
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/home/logged_in.jsx